import React from 'react';
import { CalendlyButton } from '../components/common/Calendly';

const Services: React.FC = () => {
  // Replace with your actual Calendly URL
  const calendlyUrl = 'https://calendly.com/joey-pandina';

  return (
    <div className="services-page">
      <div className="container py-5">
        <h1 className="display-4 text-center mb-5">Tutoring Services</h1>
        
        <div className="row mb-5">
          <div className="col-md-6 mb-4">
            <div className="card h-100 shadow">
              <div className="card-header bg-primary text-white">
                <h2 className="h4 my-2">Middle School Math</h2>
              </div>
              <div className="card-body">
                <p className="card-text">
                  I offer comprehensive tutoring for middle school students in all mathematics subjects, 
                  helping build strong foundations for future success.
                </p>
                <h3 className="h5 mt-4">Subjects Covered:</h3>
                <ul className="list-group list-group-flush mb-4">
                  <li className="list-group-item">Basic Arithmetic & Number Sense</li>
                  <li className="list-group-item">Fractions, Decimals & Percentages</li>
                  <li className="list-group-item">Pre-Algebra Concepts</li>
                  <li className="list-group-item">Introduction to Geometry</li>
                  <li className="list-group-item">Data Analysis & Basic Statistics</li>
                  <li className="list-group-item">Word Problems & Mathematical Reasoning</li>
                </ul>
                <h3 className="h5">Key Benefits:</h3>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">Build solid mathematical foundations</li>
                  <li className="list-group-item">Develop confidence in mathematical abilities</li>
                  <li className="list-group-item">Prepare for high school mathematics</li>
                  <li className="list-group-item">Improve problem-solving skills</li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="col-md-6 mb-4">
            <div className="card h-100 shadow">
              <div className="card-header bg-primary text-white">
                <h2 className="h4 my-2">High School Math</h2>
              </div>
              <div className="card-body">
                <p className="card-text">
                  I provide expert tutoring for high school students in all levels of mathematics, 
                  helping them excel in their courses and prepare for college.
                </p>
                <h3 className="h5 mt-4">Subjects Covered:</h3>
                <ul className="list-group list-group-flush mb-4">
                  <li className="list-group-item">Algebra I & II</li>
                  <li className="list-group-item">Geometry</li>
                  <li className="list-group-item">Trigonometry</li>
                  <li className="list-group-item">Pre-Calculus</li>
                  <li className="list-group-item">Calculus (AP or regular)</li>
                  <li className="list-group-item">Statistics</li>
                </ul>
                <h3 className="h5">Key Benefits:</h3>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">Improve grades and test scores</li>
                  <li className="list-group-item">Prepare for college entrance exams (SAT/ACT)</li>
                  <li className="list-group-item">Build critical thinking and analytical skills</li>
                  <li className="list-group-item">Gain confidence in tackling complex problems</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        
        <div className="row mb-5">
          <div className="col-lg-12">
            <div className="card shadow">
              <div className="card-header bg-primary text-white">
                <h2 className="h4 my-2">Specialized Services</h2>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <h3 className="h5">Test Preparation</h3>
                    <p>
                      Specialized tutoring to help students prepare for important tests and exams:
                    </p>
                    <ul>
                      <li>SAT/ACT Math Sections</li>
                      <li>AP Exams (Calculus AB/BC, Statistics)</li>
                      <li>State Standardized Tests</li>
                      <li>Final Exams</li>
                    </ul>
                  </div>
                  <div className="col-md-6 mb-4">
                    <h3 className="h5">Homework Help</h3>
                    <p>
                      Regular sessions to assist with:
                    </p>
                    <ul>
                      <li>Understanding and completing assignments</li>
                      <li>Reviewing difficult concepts</li>
                      <li>Preparing for upcoming quizzes and tests</li>
                      <li>Working through challenging problems</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="row">
          <div className="col-lg-12">
            <div className="card shadow">
              <div className="card-header bg-primary text-white">
                <h2 className="h4 my-2">How It Works</h2>
              </div>
              <div className="card-body">
                <div className="row text-center">
                  <div className="col-md-3 mb-4">
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center mx-auto mb-3" style={{width: '100px', height: '100px'}}>
                      <span className="h3">1</span>
                    </div>
                    <h3 className="h5">Initial Consultation</h3>
                    <p>Free 15-minute consultation to discuss your child's needs and goals</p>
                  </div>
                  <div className="col-md-3 mb-4">
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center mx-auto mb-3" style={{width: '100px', height: '100px'}}>
                      <span className="h3">2</span>
                    </div>
                    <h3 className="h5">Personalized Plan</h3>
                    <p>Development of a customized tutoring plan based on assessment</p>
                  </div>
                  <div className="col-md-3 mb-4">
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center mx-auto mb-3" style={{width: '100px', height: '100px'}}>
                      <span className="h3">3</span>
                    </div>
                    <h3 className="h5">Regular Sessions</h3>
                    <p>Engaging, focused tutoring sessions tailored to your child's learning style</p>
                  </div>
                  <div className="col-md-3 mb-4">
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center mx-auto mb-3" style={{width: '100px', height: '100px'}}>
                      <span className="h3">4</span>
                    </div>
                    <h3 className="h5">Progress Updates</h3>
                    <p>Regular updates on progress and adjustments to the learning plan as needed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="text-center mt-5">
          <h2 className="mb-4">Ready to Get Started?</h2>
          <CalendlyButton url={calendlyUrl} text="Schedule Your Free Consultation" className="btn btn-primary btn-lg" />
        </div>
      </div>
    </div>
  );
};

export default Services;
